function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "primary/close",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M26.9008264,4.77272727 L23.1818182,1.05371901 C22.6859504,0.55785124 21.9421488,0.55785124 21.446281,1.05371901 L13.6363636,8.86363636 L5.82644629,1.05371901 C5.3305785,0.55785124 4.58677685,0.55785124 4.09090909,1.05371901 L0.371900826,4.77272727 C-0.123966942,5.26859504 -0.123966942,6.01239668 0.371900826,6.50826447 L8.18181818,14.3181818 L0.371900826,22.1280992 C-0.123966942,22.623967 -0.123966942,23.3677686 0.371900826,23.8636364 L4.09090909,27.5826446 C4.58677685,28.0785123 5.3305785,28.0785123 5.82644629,27.5826446 L13.6363636,19.7727273 L21.446281,27.5826446 C21.6942149,27.8305785 22.0661157,27.9545455 22.3140496,27.9545455 C22.5619835,27.9545455 22.9338843,27.8305785 23.1818182,27.5826446 L26.9008264,23.8636364 C27.3966941,23.3677686 27.3966941,22.623967 26.9008264,22.1280992 L19.0909091,14.3181818 L26.9008264,6.50826447 C27.3966941,6.01239668 27.3966941,5.26859504 26.9008264,4.77272727 Z",
  id: "close-icon"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close-icon.18778c7f.svg";
export { SvgComponent as ReactComponent };